import { useState } from "react";

export type SetStatusPayload = { status: string; comment?: string };

const STATUS_OPTIONS = [
  { value: "completed", label: "Terminé" },
  { value: "blocked", label: "Bloqué" },
  { value: "cancelled", label: "Annulé" },
];

type SetStatusPanelProps = {
  initialStatus?: string;
  initialComment?: string;
  onSubmit: (payload: SetStatusPayload) => void;
  onCancel: () => void;
  submitting?: boolean;
};

export function SetStatusPanel({
  initialStatus = "completed",
  initialComment = "",
  onSubmit,
  onCancel,
  submitting,
}: SetStatusPanelProps) {
  const [status, setStatus] = useState(initialStatus);
  const [comment, setComment] = useState(initialComment);

  return (
    <form
      className="space-y-4"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({ status, comment: comment.trim() || undefined });
      }}
    >
      <div>
        <label htmlFor="activity-status" className="block text-sm font-medium text-text">
          Statut
        </label>
        <select
          id="activity-status"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="mt-1 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text"
        >
          {STATUS_OPTIONS.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor="activity-status-comment" className="block text-sm font-medium text-text">
          Commentaire (optionnel)
        </label>
        <textarea
          id="activity-status-comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={2}
          className="mt-1 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text"
          placeholder="Commentaire…"
        />
      </div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="rounded-md border border-border bg-surface px-3 py-1.5 text-sm text-text hover:bg-surface-muted"
        >
          Annuler
        </button>
        <button
          type="submit"
          disabled={submitting}
          className="rounded-md bg-accent px-3 py-1.5 text-sm font-medium text-white hover:bg-accent-hover disabled:opacity-50"
        >
          {submitting ? "Envoi…" : "Enregistrer"}
        </button>
      </div>
    </form>
  );
}
